<dbw-investor-viewer-accordion
  anchorId="investor-viewer-documents-ged"
  accordionTitle="Documents GED"
  [itemsCount]="$safeNavigationMigration(documents()?.totalDocumentCount)"
  [loading]="loading()">
  @if (documents(); as result) {
    <oui-tag
      accordion-description
      type="status"
      size="big"
      [status]="getMessageTagStatus(result.messageLevel)"
    >
      {{
        result.totalDocumentCount === 0
          ? "Aucun document"
          : result.totalDocumentCount + " document(s)"
      }}
    </oui-tag>
  }

  @if (loading()) {
    <dbw-state-card appearance="loading" [compact]="true">
      <p>Chargement des documents GED en cours.</p>
    </dbw-state-card>
  } @else if (error()) {
    <dbw-state-card appearance="error" [compact]="true">
      <p>{{ error() }}</p>
    </dbw-state-card>
  } @else {
    @if (documents(); as result) {
      <div class="note-banner dbw-card dbw-card--md">
        <strong>{{ result.message }}</strong>
      </div>

      <div class="reference-grid">
        <article class="identity-item dbw-card dbw-card--lg">
          <span class="identity-item__label">Total</span>
          <strong>{{ result.totalDocumentCount }}</strong>
        </article>
        <article class="identity-item dbw-card dbw-card--lg">
          <span class="identity-item__label">Actifs</span>
          <strong>{{ result.activeDocumentCount }}</strong>
        </article>
        <article class="identity-item dbw-card dbw-card--lg">
          <span class="identity-item__label">Supprimés</span>
          <strong>{{ result.inactiveDocumentCount }}</strong>
        </article>
        <article class="identity-item dbw-card dbw-card--lg">
          <span class="identity-item__label">Affichés</span>
          <strong>{{ visibleDocuments().length }}</strong>
        </article>
      </div>

      @if (result.inactiveDocumentCount > 0) {
        <div class="result-toolbar dbw-card dbw-card--lg">
          <oui-checkbox
            [checked]="showInactiveDocuments()"
            (checkedChange)="showInactiveDocuments.set($event)"
          ></oui-checkbox>
          <div>
            <strong>Afficher les documents supprimés</strong>
            <p>
              {{ result.inactiveDocumentCount }} document(s) masqué(s) par
              défaut.
            </p>
          </div>
        </div>
      }

      @if (visibleDocuments().length > 0) {
        <div class="document-list">
          @for (document of visibleDocuments(); track document.documentId) {
            <article class="document-card dbw-card dbw-card--lg">
              <div class="document-card__header">
                <div>
                  <span class="detail-item__label">{{
                    formatText(document.categoryCode)
                  }}</span>
                  <h5>{{ getDocumentTitle(document) }}</h5>
                  <p>
                    #{{ document.documentId }} •
                    {{ formatText(document.typeDocumentCode) }}
                  </p>
                </div>

                <div class="document-card__actions">
                  <oui-tag
                    type="status"
                    size="big"
                    [status]="document.isActive === true ? 'completed' : 'error'"
                  >
                    {{ document.isActive === true ? "Actif" : "Supprimé" }}
                  </oui-tag>
                </div>
              </div>

              <div class="detail-grid">
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="identity-item__label">Création</span>
                  <strong>{{ formatDate(document.creationDate) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="identity-item__label">Date de signature</span>
                  <strong>{{ formatDate(document.signatureDate) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="identity-item__label">Investisseur GED</span>
                  <strong>{{ formatText(document.investorId) }}</strong>
                </article>
                <article class="detail-item dbw-card dbw-card--lg">
                  <span class="identity-item__label">Consultant</span>
                  <dbw-consultant-card
                    [code]="formatText(document.consultantCode)"
                    [name]="'-'"
                    [statusCode]="document.consultantStatusCode"
                  ></dbw-consultant-card>
                </article>
              </div>

              @if (document.signatories.length > 0) {
                <div class="mini-block">
                  <span class="detail-item__label">Signataires</span>
                  <div class="field-chip-list">
                    @for (signatory of document.signatories; track $index) {
                      <span class="field-chip">{{ signatory.label }}</span>
                    }
                  </div>
                </div>
              }
            </article>
          }
        </div>
      } @else {
        <dbw-state-card appearance="info" [compact]="true">
          <p>Aucun document n'est visible avec le filtre courant.</p>
        </dbw-state-card>
      }
    } @else {
      <dbw-state-card appearance="info" [compact]="true">
        <p>Les documents GED ne sont pas encore disponibles.</p>
      </dbw-state-card>
    }
  }
</dbw-investor-viewer-accordion>
